import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { RaisedButton, Dialog, FlatButton } from 'material-ui';
import DraftForm from './create-dummy-templates-wizard/template-draft-form';
import UpdateRateConversionSetting from './update-rate-conversion-settings';
import SendMessageRL from './send-message';
import TemplateListForRC, { getStatus } from './template-list-for-RC';


const propTypes = {
  realActorEmail: PropTypes.string,
  crId: PropTypes.string,
  rateConversionSetting: PropTypes.string,
  rateConversionStatus: PropTypes.string,
  priority: PropTypes.string,
  assignee: PropTypes.object,
  dummySupplierForCR: PropTypes.object,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  createTemplatesInDummyAcct: PropTypes.func,
  buyerCompanyName: PropTypes.string,
  creatingTemplates: PropTypes.bool,
  updateRCStatus: PropTypes.func,
  supplierCompanyName: PropTypes.string,
  rateLoadingWizard: PropTypes.object,
  updateWizardData: PropTypes.func,
  openSendMsg: PropTypes.func,
  sendMsgOpen: PropTypes.bool,
  openSubmitRatesAsDL: PropTypes.func,
  buyerEmail: PropTypes.string,
  deleteRateSheet: PropTypes.func,
};

class RateConversion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wizardOpen: false,
      draftIds: [],
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.creatingTemplates && !nextProps.creatingTemplates) {
      this.setState({ wizardOpen: false });
    }
  }

  openWizard = () => this.setState({ wizardOpen: true });
  closeWizard = () => this.setState({ wizardOpen: false });
  createTemplatesInDummyAcct = () => {
    const { crId, dummySupplierForCR, supplierCompanyName, rateLoadingWizard } = this.props;
    this.props.createTemplatesInDummyAcct({
      crId,
      dummyCompanyId: dummySupplierForCR.accountId,
      supplierCompanyName,
      ...rateLoadingWizard,
    });
  };
  selectTemplate = draftId => () => this.setState({ draftIds: [...this.state.draftIds, draftId] })
  openSubmitRatesAsDL = () => this.props.openSubmitRatesAsDL({ emails: [this.props.buyerEmail] })
  render() {
    const {
      rateConversionSetting,
      dummySupplierForCR: {
        templates: templateList = [],
      },
      creatingTemplates,
      crId,
      rateLoadingWizard: {
        oneOrMulti,
        newDraftStartDate,
        newDraftEndDate,
        templateName,
        locations,
      },
      updateWizardData,
      openSendMsg,
      sendMsgOpen,
      realActorEmail,
      deleteRateSheet,
    } = this.props;
    const isDL = realActorEmail === 'admin@tourconnect.com'
      || realActorEmail === 'dl@tourconnect.com';
    const {
      wizardOpen,
    } = this.state;
    const disableBtn = !(
      oneOrMulti
      && newDraftStartDate
      && newDraftEndDate
      && templateName
      && locations.some(obj => obj.checked)
    );
    return (
      <div style={{ marginBottom: '24px' }}>
      <div className="flex-center" style={{ marginBottom: '1em' }}>
        <b>
          Require Supplier Signature:&nbsp;
        </b>
        {rateConversionSetting === 'opt-in' ? 'Yes' : 'No'} &nbsp;&nbsp;<UpdateRateConversionSetting
          contractId={crId}
          setting={rateConversionSetting}
        />
      </div>
        <div className="flex-tc-sb" style={{ marginTop: '2em' }}>
          <RaisedButton
            label="Create Rate Sheet"
            secondary
            onClick={this.openWizard}
          />
          <div>
            <FlatButton
              style={{ marginLeft: '1em', border: '1px solid #00bcd4' }}
              label="Send Message"
              secondary
              onClick={openSendMsg}
            />
            {
              Boolean(isDL && templateList.filter(o => getStatus(o) === '100% completed').length) && (
                <RaisedButton
                  style={{ marginLeft: '1em' }}
                  label="Submit Rates"
                  secondary
                  onClick={this.openSubmitRatesAsDL}
                />
              )
            }
          </div>
        </div>
        {
          Boolean(templateList.length)
          && (
            <TemplateListForRC
              templates={templateList}
              deleteRateSheet={deleteRateSheet}
            />
          )
        }
        <Dialog
          open={wizardOpen}
          onRequestClose={this.closeWizard}
          title={
            <div style={{ backgroundColor: '#00bcd4', color: '#fff' }}>
              {templateList.length ? 'Add A Rate Sheet' : 'Create A Rate Sheet'}
            </div>
          }
          actions={[
            <FlatButton
              key="cancel"
              label="cancel"
              primary
              onClick={this.closeWizard}
            />,
            <FlatButton
              key="start"
              label={templateList.length ? 'Create' : 'Start'}
              secondary
              onClick={this.createTemplatesInDummyAcct}
              disabled={disableBtn || creatingTemplates}
            />,
          ]}
          autoScrollBodyContent
        >
          <DraftForm
            {...this.props.rateLoadingWizard}
            updateProps={updateWizardData}
          />
        </Dialog>
        <SendMessageRL/>
      </div>
    );
  }
}


RateConversion.propTypes = propTypes;

export default connect(({ user, dummyAcct }) => ({
  ...dummyAcct.inCR,
  realActorEmail: user.get('realActorEmail'),
  sendMsgOpen: dummyAcct.sendMsg.open,
}), {
  openSendMsg: () => ({ type: '{rl-send-message}OPEN_SEND_MESSAGE' }),
  openSubmitRatesAsDL: payload => ({ type: '{rl-send-message} OPEN_SEND_MESSAGE_AS_SUBMIT_RATES_AS_DL', payload }),
  createTemplatesInDummyAcct: payload => ({ type: '[contract-request]CREATE_TEMPLATE_IN_DUMMY_ACCOUNT_FOR_CR', payload }),
  updateWizardData: payload => ({ type: '[contract-request] UPDATE_RL_WIZARD_DATA', payload }),
  deleteRateSheet: payload => ({ type: '[contract-request] DELETE_RATE_SHEET', payload }),
})(RateConversion);



// WEBPACK FOOTER //
// ./src/app/components/contracting/dummy-account/rate-conversion.jsx